import { render, staticRenderFns } from "./DomainComAuSettingsCard.vue?vue&type=template&id=56a46780"
import script from "./DomainComAuSettingsCard.vue?vue&type=script&lang=ts"
export * from "./DomainComAuSettingsCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports